/**
 * Google Analytics (gtag.js) helper functions
 */

export const GA_MEASUREMENT_ID = 'G-5X29V4B40T'

// gtag function type declaration
declare global {
  interface Window {
    gtag: (
      command: 'config' | 'event' | 'js',
      targetId: string | Date,
      config?: Record<string, unknown>
    ) => void
    dataLayer: unknown[]
  }
}

/**
 * Send page view to Google Analytics
 * Used for SPA route changes
 */
export function pageview(url: string): void {
  if (typeof window.gtag !== 'function') return
  window.gtag('config', GA_MEASUREMENT_ID, {
    page_path: url,
  })
}

/**
 * Send event to Google Analytics
 */
export function event(
  action: string,
  params?: {
    event_category?: string
    event_label?: string
    value?: number
    [key: string]: unknown
  }
): void {
  if (typeof window.gtag !== 'function') return
  window.gtag('event', action, params)
}

// CV Event: Figma plugin link click
export function trackFigmaPluginClick(location: string): void {
  event('click_figma_plugin', {
    event_category: 'conversion',
    event_label: location,
  })
}
